import { useTranslation } from 'react-i18next';
import { Calendar, Check, Users } from 'lucide-react';

export default function EnrollmentPreview({
    selectedMembers,
    selectedSessions,
    onConfirm,
    sendNotification,
    onToggleNotification,
}) {
    const { t } = useTranslation();
    const totalEnrollments = selectedMembers.length * selectedSessions.length;
    const canConfirm = selectedMembers.length > 0 && selectedSessions.length > 0;

    return (
        <div className="shrink-0 border-t border-gray-200 bg-white px-4 py-3 shadow-[0_-8px_24px_rgba(15,23,42,0.04)] dark:border-gray-800 dark:bg-gray-900 sm:px-6">
            <div className="flex flex-col gap-3 xl:flex-row xl:items-center">
                <div className="flex flex-1 flex-wrap items-center gap-x-5 gap-y-2">
                    <p className="text-sm font-semibold text-gray-900 dark:text-gray-50">
                        {t('gym.bulkEnrollment.preview.title')}
                    </p>
                    <span className="inline-flex items-center gap-1.5 text-sm text-gray-600 dark:text-gray-300">
                        <Users size={16} className="text-blue-600" aria-hidden />
                        <strong className="text-gray-900 dark:text-white">{selectedMembers.length}</strong>
                        {t('gym.bulkEnrollment.preview.users')}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm text-gray-600 dark:text-gray-300">
                        <Calendar size={16} className="text-indigo-600" aria-hidden />
                        <strong className="text-gray-900 dark:text-white">{selectedSessions.length}</strong>
                        {t('gym.bulkEnrollment.preview.sessions')}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm text-gray-600 dark:text-gray-300">
                        <Check size={16} className="text-emerald-600" aria-hidden />
                        <strong className="text-gray-900 dark:text-white">{totalEnrollments}</strong>
                        {t('gym.bulkEnrollment.preview.total')}
                    </span>
                </div>

                <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700 dark:text-gray-200">
                    <input
                        type="checkbox"
                        checked={sendNotification}
                        onChange={(event) => onToggleNotification(event.target.checked)}
                        className="h-4 w-4 rounded text-indigo-600 focus:ring-indigo-500"
                    />
                    {t('gym.bulkEnrollment.preview.sendNotifications')}
                </label>

                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={!canConfirm}
                    className={`inline-flex items-center justify-center gap-2 rounded-lg px-5 py-2.5 text-sm font-semibold text-white transition-colors ${
                        canConfirm
                            ? 'bg-indigo-600 hover:bg-indigo-700'
                            : 'cursor-not-allowed bg-gray-300 dark:bg-gray-700'
                    }`}
                >
                    <Check size={18} aria-hidden />
                    {t('gym.bulkEnrollment.preview.confirmButton')} ({totalEnrollments})
                </button>
            </div>
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                {canConfirm
                    ? t('gym.bulkEnrollment.preview.confirmationMessage', { count: totalEnrollments })
                    : t('gym.bulkEnrollment.preview.selectAtLeastOne')}
            </p>
        </div>
    );
}
